import { paymentsTypes } from './payments.types';

const INITIAL_STATE = {
  bills: {
    loading: false,
    data: null,
  },
  packages: {
    loading: false,
    data: null,
  },
  packageTypes: {},
  useWhatsappPackages: {},
  selectedPackageType: 0,
  selectedPackage: 'premium',
  selectedDuration: 'yearly',
  isOfficialBillNeeded: false,
  useCredit: false,
  selectedConversationCount: 500,
  baseConversationPrice: {
    fa: 900,
    en: 1,
  },
  payablePrice: 0,
  isAutoUpgradeVisible: false,
  selectedBank: '',
  selectedUpgradeMethod: 'manual',
  paymentInfo: {
    loading: false,
    data: null,
  },
  displayInputPaymentInfoModal: false,
  isSelectBankVisible: false,
  discountInfo: null,
  makeInvoiceLoading: false,
  discountError: {
    show: false,
    errorMsg: '',
  },
};

const paymentsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case paymentsTypes.SET_SHOW_DISCOUNT_ERROR:
      return {
        ...state,
        discountError: {
          ...state.discountError,
          show: action.payload.show,
          errorMsg: action.payload.discountError,
        },
      };

    case paymentsTypes.SET_BILLS:
      return {
        ...state,
        bills: {
          loading: false,
          data: action.payload,
        },
      };
    case paymentsTypes.LOADING_BILLS:
      return {
        ...state,
        bills: {
          ...state.bills,
          loading: true,
        },
      };

    case paymentsTypes.SET_PACKAGES:
      return {
        ...state,
        packages: {
          loading: false,
          data: action.payload,
        },
      };

    case paymentsTypes.SET_PACKAGE_TYPES:
      return {
        ...state,
        packageTypes: action.payload,
      };

    case paymentsTypes.LOADING_PACKAGES:
      return {
        ...state,
        packages: {
          ...state.packages,
          loading: true,
        },
      };
    case paymentsTypes.SET_DISCOUNT_CODE:
      return {
        ...state,
        discountInfo: action.payload.discountInfo,
        discountCode: action.payload.discountCode,
      };
    case paymentsTypes.SET_SELECTED_PACKAGE:
      return {
        ...state,
        selectedPackage: action.payload,
      };
    case paymentsTypes.SET_SELECTED_PACKAGE_TYPE:
      return {
        ...state,
        selectedPackageType: action.payload,
      };
    case paymentsTypes.SET_SELECTED_DURATION:
      return {
        ...state,
        selectedDuration: action.payload,
      };
    case paymentsTypes.SET_IS_OFFICIAL_BILL_NEEDED:
      return {
        ...state,
        isOfficialBillNeeded: action.payload,
      };
    case paymentsTypes.SET_USE_CREDIT:
      return {
        ...state,
        useCredit: action.payload,
      };
    case paymentsTypes.SET_INVOICE_ID:
      return {
        ...state,
        invoiceId: action.payload,
      };
    case paymentsTypes.MAKE_INVOICE_LOADING:
      return {
        ...state,
        makeInvoiceLoading: action.payload,
      };
    case paymentsTypes.SET_SELECTED_CONVERSATION_COUNT:
      return {
        ...state,
        selectedConversationCount: action.payload,
      };
    case paymentsTypes.SET_PAYABLE_PRICE:
      return {
        ...state,
        payablePrice: action.payload,
      };
    case paymentsTypes.SET_IS_AUTO_UPGRADE_VISIBLE:
      return {
        ...state,
        isAutoUpgradeVisible: action.payload,
      };
    case paymentsTypes.SET_SELECTED_BANK:
      return {
        ...state,
        selectedBank: action.payload,
      };
    case paymentsTypes.SET_SELECTED_UPGRADE_METHOD:
      return {
        ...state,
        selectedUpgradeMethod: action.payload,
      };
    case paymentsTypes.SET_PAYMENT_INFO:
      return {
        ...state,
        paymentInfo: { loading: false, data: action.payload },
      };
    case paymentsTypes.LOADIN_PAYMENT_INFO:
      return {
        ...state,
        paymentInfo: { ...state.paymentInfo, loading: true },
      };
    case paymentsTypes.DISPLAY_INPUT_PAYMENT_INFO_MODAL:
      return {
        ...state,
        displayInputPaymentInfoModal: action.payload,
      };
    case paymentsTypes.SET_IS_SELECT_BANK_VISIBLE:
      return {
        ...state,
        isSelectBankVisible: action.payload,
      };

    case paymentsTypes.SET_USE_WHATSAPP_PACKAGES:
      return {
        ...state,
        useWhatsappPackages: action.payload,
      };
    default:
      return state;
  }
};

export default paymentsReducer;
